var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "planProductInquiry" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "70%",
            modal: false,
            "custom-class": "big",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("product-inquiry-type-tab", {
            ref: "inquiryTypeTab",
            staticStyle: { background: "white", width: "12rem" },
            attrs: {
              sendButtom: "按着这个行程请尽快给",
              sendButtom2: "我提供产品",
              nowShowType: _vm.nowShowType,
            },
            on: { tabCheckType: _vm.tabCheckType, sumitBox: _vm.sumitBox },
          }),
          _c("div", { staticClass: "dialogMain" }, [
            _c("div", { staticClass: "dialogFa" }, [
              _c("p", { staticClass: "dialogLeftP1" }, [
                _vm._v("第一步：选择日期"),
              ]),
              _c("div", { staticClass: "dialogLeft" }, [
                _c(
                  "div",
                  { staticClass: "dialogRightChoose" },
                  _vm._l(_vm.planDays, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          border: "1px solid #EAEAEA",
                          padding: "0.1rem",
                        },
                        style:
                          item.planDay == _vm.planDay.planDay
                            ? "box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 7px 2px;"
                            : "",
                        on: {
                          click: function ($event) {
                            return _vm.handleCheckedCitiesChange(item)
                          },
                        },
                      },
                      [
                        _c("div", [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.dateFormatYMD(item.planDate, "-")) +
                                "  "
                            ),
                          ]),
                          _c("span", { staticClass: "span2" }, [
                            _vm._v("D" + _vm._s(item.planDay) + " "),
                          ]),
                          item.cityList.length > 0
                            ? _c(
                                "span",
                                { staticClass: "span3" },
                                _vm._l(
                                  item.cityList,
                                  function (city, cityIndex) {
                                    return _c("span", { key: cityIndex }, [
                                      _vm._v(" " + _vm._s(city.cityName) + " "),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "0.18rem",
                                    color: "#48AD19",
                                  },
                                },
                                [_vm._v("请完善行程，否则行程无法发送成功")]
                              ),
                        ]),
                        _vm.nowShowType == "hotel"
                          ? _c(
                              "div",
                              {
                                key: item.planDay,
                                staticClass: "dialogRightChooseMain",
                              },
                              [
                                item.inquiryObj &&
                                JSON.stringify(item.inquiryObj.hotel) !==
                                  "{}" &&
                                item.inquiryObj.hotel
                                  ? [
                                      _c("hotel-product-inquiry-show", {
                                        attrs: {
                                          hotelData: item.inquiryObj.hotel,
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.clearData(item)
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm.nowShowType == "site"
                          ? _c(
                              "div",
                              {
                                key: item.planDay,
                                staticClass: "dialogRightChooseMain",
                              },
                              [
                                item.inquiryObj &&
                                JSON.stringify(item.inquiryObj.site) !== "{}" &&
                                item.inquiryObj.site
                                  ? [
                                      _c(
                                        "div",
                                        [
                                          _c("site-product-inquiry-show", {
                                            attrs: {
                                              item: item.inquiryObj.site,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.clearData(item)
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _c(
                              "div",
                              {
                                key: item.planDay,
                                staticClass: "dialogRightChooseMain",
                              },
                              [
                                item.inquiryObj &&
                                JSON.stringify(
                                  item.inquiryObj[_vm.nowShowType]
                                ) !== "{}" &&
                                item.inquiryObj[_vm.nowShowType]
                                  ? [
                                      _c("div", [
                                        item.inquiryObj[_vm.nowShowType].adult >
                                          0 ||
                                        item.inquiryObj[_vm.nowShowType]
                                          .children > 0
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.inquiryObj[
                                                      _vm.nowShowType
                                                    ].adult
                                                  ) +
                                                  "成人" +
                                                  _vm._s(
                                                    item.inquiryObj[
                                                      _vm.nowShowType
                                                    ].children
                                                  ) +
                                                  "儿童 "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "0.05rem",
                                            },
                                          },
                                          [
                                            _vm.nowShowType == "visa"
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "0.05rem",
                                                    },
                                                  },
                                                  _vm._l(
                                                    item.inquiryObj[
                                                      _vm.nowShowType
                                                    ].countrys,
                                                    function (item1, index1) {
                                                      return _c(
                                                        "span",
                                                        { key: index1 },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item1.countryName
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _vm._l(
                                              item.inquiryObj[_vm.nowShowType][
                                                _vm.nowShowTypeObj.propName
                                              ],
                                              function (item1, index1) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: index1,
                                                    staticStyle: {
                                                      "margin-top": "0.05rem",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item1.addType)
                                                      ),
                                                    ]),
                                                    _vm.nowShowType == "spot" &&
                                                    item1.cityName &&
                                                    item1.cityName != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " 目的地 " +
                                                              _vm._s(
                                                                item1.cityName
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.spotName
                                                              ) +
                                                              " 的" +
                                                              _vm._s(
                                                                item1.spotType
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.nowShowType ==
                                                      "traffic" &&
                                                    item1.trafficType &&
                                                    item1.trafficType != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " 车型 " +
                                                              _vm._s(
                                                                item1.trafficType
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.busType
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.busNumber
                                                              ) +
                                                              "辆 "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.nowShowType ==
                                                      "guide" &&
                                                    item1.busNumber &&
                                                    item1.busNumber != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item1.busNumber
                                                              ) +
                                                              "位 " +
                                                              _vm._s(
                                                                item1.trafficType
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.nowShowType ==
                                                      "communication" &&
                                                    item1.cityName &&
                                                    item1.cityName != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " 出发地 " +
                                                              _vm._s(
                                                                item1.cityName
                                                              ) +
                                                              " 目的地 " +
                                                              _vm._s(
                                                                item1.endCityName
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.trafficType
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.expectFlight
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.nowShowType ==
                                                      "restaurant" &&
                                                    item1.cityName &&
                                                    item1.cityName != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item1.cityName
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.number
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.mealType
                                                              ) +
                                                              " 预算" +
                                                              _vm._s(
                                                                item1.budgetPrice
                                                              ) +
                                                              _vm._s(
                                                                item1.currency
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    item1.visaType &&
                                                    item1.visaType != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item1.visaType
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.visaContent
                                                              ) +
                                                              " "
                                                          ),
                                                          item.inquiryObj[
                                                            _vm.nowShowType
                                                          ].countrys.length == 0
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "var(--bottomBtnColor)",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "!!!没有选择签证国家,询价将发送不成功"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.nowShowType ==
                                                      "business" &&
                                                    item1.cityName &&
                                                    item1.cityName != ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item1.cityName
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.businessType
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.businessIndustry
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.time
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item1.objective
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.nowShowType ==
                                                      "charact" ||
                                                    _vm.nowShowType == "service"
                                                      ? _c("span", [
                                                          item1.cityName &&
                                                          item1.cityName != ""
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item1.cityName
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item1.content
                                                                    )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          (!item1.cityName ||
                                                            item1.cityName ==
                                                              "") &&
                                                          item.inquiryObj[
                                                            _vm.nowShowType
                                                          ].remarks &&
                                                          item.inquiryObj[
                                                            _vm.nowShowType
                                                          ].remarks != ""
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "var(--bottomBtnColor)",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "!!!没有选择城市,询价将发送不成功"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            item.inquiryObj[_vm.nowShowType]
                                              .remarks &&
                                            item.inquiryObj[_vm.nowShowType]
                                              .remarks != ""
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "0.05rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "备注：" +
                                                        _vm._s(
                                                          item.inquiryObj[
                                                            _vm.nowShowType
                                                          ].remarks
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.clearData(item)
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c("div", { staticClass: "dialogRightTitle" }, [
              _c("p", { staticClass: "dialogLeftP1" }, [
                _vm._v(" 第二步：录入标准 "),
                _c("span", [
                  _vm._v("求助客服"),
                  _c("img", { attrs: { src: require("@/assets/png/wx.png") } }),
                ]),
                _c("span", { staticClass: "Dline" }),
              ]),
              _vm.planDay.inquiryObj
                ? _c(
                    "div",
                    { staticClass: "dialogRight" },
                    [
                      _vm.nowShowType == "hotel"
                        ? _c("hotel-product-inquiry", {
                            attrs: { hotelData: _vm.planDay.inquiryObj.hotel },
                          })
                        : _vm.nowShowType == "site"
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "0.05rem",
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "margin-right": "0.1rem" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.planDay.inquiryObj.site.useDate
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "1.1rem" },
                                      attrs: {
                                        placeholder: "请选择",
                                        size: "mini",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeCity(
                                            $event,
                                            _vm.planDay.inquiryObj.site
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.planDay.inquiryObj.site.cityName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.planDay.inquiryObj.site,
                                            "cityName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "planDay.inquiryObj.site.cityName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.planDay.cityList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.cityName,
                                            value: item,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "margin-left": "0.1rem" },
                                    },
                                    [_vm._v("活动时段：")]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "1.9rem" },
                                      attrs: {
                                        placeholder: "请选择天数",
                                        size: "mini",
                                      },
                                      model: {
                                        value:
                                          _vm.planDay.inquiryObj.site.useDay,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.planDay.inquiryObj.site,
                                            "useDay",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "planDay.inquiryObj.site.useDay",
                                      },
                                    },
                                    _vm._l(_vm.durationOption, function (text) {
                                      return _c("el-option", {
                                        key: text,
                                        attrs: { label: text, value: text },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("site-product-inquiry", {
                                attrs: {
                                  siteData: _vm.planDay.inquiryObj.site,
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "dialogRightContent" },
                            [
                              _c("people-box", {
                                attrs: {
                                  showRenNumber: false,
                                  spotData:
                                    _vm.planDay.inquiryObj[_vm.nowShowType],
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "dialogRightContentButton" },
                                [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        "亲，您需要的" +
                                          _vm._s(_vm.nowShowTypeObj.desc) +
                                          "是："
                                      ),
                                    ]),
                                  ]),
                                  _vm.nowShowType == "visa"
                                    ? _c("div", [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "margin-top": "0.1rem",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.planDay.inquiryObj[
                                                      _vm.nowShowType
                                                    ].countrys,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planDay.inquiryObj[
                                                        _vm.nowShowType
                                                      ],
                                                      "countrys",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planDay.inquiryObj[nowShowType].countrys",
                                                },
                                              },
                                              _vm._l(
                                                _vm.planDay.countryList,
                                                function (item, index) {
                                                  return _c(
                                                    "el-checkbox",
                                                    {
                                                      key: index,
                                                      attrs: { label: item },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.countryName)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "0.1rem",
                                            },
                                          },
                                          [_c("b", [_vm._v("您申请的是")])]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._l(
                                    _vm.planDay.inquiryObj[_vm.nowShowType][
                                      _vm.nowShowTypeObj.propName
                                    ],
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "content" },
                                        [
                                          _vm.nowShowType == "spot"
                                            ? [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(item.useDate)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1.1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.cityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "cityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.cityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c("spot-autocomplete", {
                                                      attrs: { spotItem: item },
                                                    }),
                                                    _c("label", [_vm._v("的")]),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio-group",
                                                      {
                                                        staticStyle: {
                                                          "margin-left":
                                                            "1.12rem",
                                                        },
                                                        model: {
                                                          value: item.spotType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "spotType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.spotType",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "散客票",
                                                            },
                                                          },
                                                          [_vm._v("散客票")]
                                                        ),
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "团队票",
                                                            },
                                                          },
                                                          [_vm._v("团队票")]
                                                        ),
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "专业讲解",
                                                            },
                                                          },
                                                          [_vm._v("专业讲解")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .spotProductInquiryList,
                                                        index: index,
                                                        addObj:
                                                          _vm.spotProductInquiryList,
                                                        addAction: true,
                                                      },
                                                      on: {
                                                        addSpotType:
                                                          _vm.addSpotType,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm.nowShowType == "traffic"
                                            ? [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v("  "),
                                                    _c(
                                                      "traffic-product-inquiry",
                                                      {
                                                        staticClass:
                                                          "trafficProductInquiry",
                                                        attrs: {
                                                          carItem: item,
                                                        },
                                                      }
                                                    ),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .trafficProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.trafficProductInquiries,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm.nowShowType == "communication"
                                            ? [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(item.useDate)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1.1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.cityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "cityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.cityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c("span", [
                                                      _vm._v("  至"),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1.1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item,
                                                              1
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.endCityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "endCityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.endCityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c("label", [
                                                      _vm._v("的什么交通服务"),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "0.69rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value:
                                                            item.trafficType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "trafficType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.trafficType",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.communicationOptionOne,
                                                        function (text, i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "p",
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "2.93rem",
                                                        margin:
                                                          "0 0.1rem 0 0.25rem",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "期望的班(船)/次或时间",
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          item.expectFlight,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "expectFlight",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.expectFlight",
                                                      },
                                                    }),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .bigTrafficProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.bigTrafficProductInquiries,
                                                        addAction: true,
                                                      },
                                                      on: {
                                                        addSpotType:
                                                          _vm.addSpotType,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm.nowShowType == "restaurant"
                                            ? [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(item.useDate)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1.1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.cityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "cityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.cityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "0.77rem",
                                                      },
                                                      attrs: {
                                                        placeholder: "请填写",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          item.number =
                                                            item.number.replace(
                                                              /[^\d]/g,
                                                              ""
                                                            )
                                                        },
                                                      },
                                                      model: {
                                                        value: item.number,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "number",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.number",
                                                      },
                                                    }),
                                                    _c("label", [_vm._v("顿")]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value: item.mealType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "mealType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.mealType",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.restaurantOptionOne,
                                                        function (text, i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "p",
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "1.62rem",
                                                        margin:
                                                          "0 0.1rem 0 0.25rem",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "预算（如有）",
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value: item.budgetPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "budgetPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.budgetPrice",
                                                      },
                                                    }),
                                                    _c(
                                                      "currency-autocomplete",
                                                      {
                                                        attrs: {
                                                          obj: item,
                                                          sizeType: "mini",
                                                          styleStr:
                                                            "width:1rem",
                                                        },
                                                      }
                                                    ),
                                                    _vm._v("  "),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ].mealProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.mealProductInquiries,
                                                        addAction: true,
                                                      },
                                                      on: {
                                                        addSpotType:
                                                          _vm.addSpotType,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm.nowShowType == "guide"
                                            ? [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "0.5rem",
                                                      },
                                                      attrs: {
                                                        placeholder: "",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          item.busNumber =
                                                            item.busNumber.replace(
                                                              /[^\d]/g,
                                                              ""
                                                            )
                                                        },
                                                      },
                                                      model: {
                                                        value: item.busNumber,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "busNumber",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.busNumber",
                                                      },
                                                    }),
                                                    _c("label", [_vm._v("位")]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1.5rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value:
                                                            item.trafficType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "trafficType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.trafficType",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.guideOptionOne,
                                                        function (text, i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .trafficProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.trafficProductInquiries,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm.nowShowType == "visa"
                                            ? [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "120px",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value: item.visaType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "visaType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.visaType",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.visaOptionOne,
                                                        function (text, i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "120px",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value:
                                                            item.visaContent,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "visaContent",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.visaContent",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.visaOptionTwo,
                                                        function (text, i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ].visaProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.visaProductInquiries,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm.nowShowType == "business"
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "businessType",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(item.useDate)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.cityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "cityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.cityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: {
                                                          label: "商务拜访",
                                                        },
                                                        model: {
                                                          value:
                                                            item.businessType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "businessType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.businessType",
                                                        },
                                                      },
                                                      [_vm._v("商务拜访")]
                                                    ),
                                                    _vm._v("  "),
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "邀请函及商务联系",
                                                        },
                                                        model: {
                                                          value:
                                                            item.businessType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "businessType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.businessType",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "邀请函及商务联系"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "1rem",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          item.businessType ==
                                                          "商务拜访"
                                                            ? "您想拜访的行业"
                                                            : "您的对口行业",
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          item.businessIndustry,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "businessIndustry",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.businessIndustry",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "p",
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "2.3rem",
                                                        "margin-left":
                                                          "0.25rem",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          item.businessType ==
                                                          "商务拜访"
                                                            ? "拜访时间和拜访时长"
                                                            : "邀请时间和邀请时长",
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value: item.time,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "time",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.time",
                                                      },
                                                    }),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "2.1rem",
                                                        "margin-right":
                                                          "0.05rem",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "要求及拜访目的",
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value: item.objective,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "objective",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.objective",
                                                      },
                                                    }),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .businessProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.businessProductInquiries,
                                                        addAction: true,
                                                      },
                                                      on: {
                                                        addSpotType:
                                                          _vm.addSpotType,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm.nowShowType == "charact"
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "businessType",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(item.useDate)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.cityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "cityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.cityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c(
                                                      "b",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "0.05rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "安排什么特色体验"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1.2rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                          "allow-create": "",
                                                          filterable: "",
                                                        },
                                                        model: {
                                                          value: item.content,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "content",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.content",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.charactOptionOne,
                                                        function (
                                                          text,
                                                          index1
                                                        ) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: index1,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .chractProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.chractProductInquiries,
                                                        addAction: true,
                                                      },
                                                      on: {
                                                        addSpotType:
                                                          _vm.addSpotType,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm.nowShowType == "service"
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "businessType",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          width: "0.15rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.addType)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(item.useDate)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "1rem",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeCity(
                                                              $event,
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.cityName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "cityName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.cityName",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDay.cityList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.cityName,
                                                                value: item,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c(
                                                      "b",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "0.05rem",
                                                        },
                                                      },
                                                      [_vm._v("安排什么服务")]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "120px",
                                                        },
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value: item.content,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "content",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.content",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.serviceOptionOne,
                                                        function (
                                                          text,
                                                          index1
                                                        ) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: index1,
                                                              attrs: {
                                                                label: text,
                                                                value: text,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v("  "),
                                                    _c("operation-button", {
                                                      staticClass:
                                                        "operationButton",
                                                      attrs: {
                                                        arr: _vm.planDay
                                                          .inquiryObj[
                                                          _vm.nowShowType
                                                        ]
                                                          .chractProductInquiries,
                                                        index: index,
                                                        addObj:
                                                          _vm.chractProductInquiries,
                                                        addAction: true,
                                                      },
                                                      on: {
                                                        addSpotType:
                                                          _vm.addSpotType,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  _c("p", [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.planDay.inquiryObj[
                                              _vm.nowShowType
                                            ].remarks,
                                          expression:
                                            "planDay.inquiryObj[nowShowType].remarks",
                                        },
                                      ],
                                      staticStyle: {
                                        "margin-top": "0.2rem",
                                        width: "5.6rem",
                                        border: "none",
                                        padding: "0.05rem",
                                      },
                                      attrs: {
                                        size: "mini",
                                        placeholder: _vm.nowShowTypeObj
                                          .placeholder
                                          ? _vm.nowShowTypeObj.placeholder
                                          : "请在此处填写其他您想告知我们的需求，我们将尽快为您提供您需要的专属特价",
                                      },
                                      domProps: {
                                        value:
                                          _vm.planDay.inquiryObj[
                                            _vm.nowShowType
                                          ].remarks,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.planDay.inquiryObj[
                                              _vm.nowShowType
                                            ],
                                            "remarks",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
      _c("send-inquiry-dialog", {
        ref: "sendInquiry",
        attrs: { identity: "供应商" },
        on: { closeDialog: _vm.closeDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }